import { BrowserRouter } from 'react-router-dom';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { Toaster } from 'react-hot-toast';
import { msalConfig } from '@/config/msalConfig';
import { AuthProvider } from '@/contexts/AuthContext';
import { BrandingProvider } from '@/contexts/BrandingContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { StateProvider } from '@/state/providers';
import { AppRoutes } from '@/routes/AppRoutes';

const msalInstance = new PublicClientApplication(msalConfig);

export default function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <StateProvider>
        <BrowserRouter>
          <AuthProvider>
            <BrandingProvider>
              <ThemeProvider>
                <AppRoutes />
                <Toaster
                  position="top-right"
                  toastOptions={{
                    duration: 4000,
                    style: { fontSize: 13, fontFamily: 'inherit', borderRadius: 8 },
                    success: { iconTheme: { primary: 'var(--brand-primary, #219268)', secondary: '#ffffff' } },
                    loading: { iconTheme: { primary: 'var(--brand-primary, #219268)', secondary: '#ffffff' } },
                  }}
                />
              </ThemeProvider>
            </BrandingProvider>
          </AuthProvider>
        </BrowserRouter>
      </StateProvider>
    </MsalProvider>
  );
}
